import dayjs from 'dayjs';
import notify from '@/modules/notify';

export const addEnterListener = (element, callback) => {
  element.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') callback(event);
  });
};

export const animateNumber = (element, total, formatting) => {
  const start = 0;
  const duration = 300;

  let startTime = null;

  function updateNumber(timestamp) {
    if (!startTime) startTime = timestamp;

    const elapsed = timestamp - startTime;
    const progress = Math.min(elapsed / duration, 1);
    const currentValue = Math.floor(progress * (total - start) + start);

    element.textContent = formatting ? formatting(currentValue) : currentValue;

    if (progress < 1) requestAnimationFrame(updateNumber);
  }

  requestAnimationFrame(updateNumber);
};

export const boldAnimate = (el, text) => {
  if (!el) return;

  if (text) el.innerText = text;

  el.style.transition = 'font-weight 1s ease';
  el.style.fontWeight = 'bold';

  setTimeout(() => {
    el.style.fontWeight = '';
  }, 2000);
};

export const concat = (array1, array2) => [].concat(array1, array2);

export const csrfToken = () => metaValue('csrf-token');

export const currentDomain = () => 'https://www.danca.com';

export const defaultDateMask = () => 'DD/MM/YY';

export const fadeOutAndRemove = (element, options = {}) => {
  const { speed = 0.4 } = options;

  element.style.transition = `opacity ${speed}s ease, height ${speed}s ease`;
  element.style.height = `${element.offsetHeight}px`;

  requestAnimationFrame(() => {
    element.style.height = '0px';
    element.style.opacity = '0';
    element.style.overflow = 'hidden';
  });

  element.addEventListener('transitionend', () => element.remove(), { once: true });
};

export const fillAndAnimate = (el, json, attributes) => {
  for (let i = 0; i < attributes.length; i++) {
    const value = json[attributes[i].replace('-', '_')];
    const place = el.querySelector(`[data-${attributes[i]}]`);

    place.innerText = value;

    boldAnimate(place);
  }
};

export const focusFirstField = (wrapper) => {
  const fields = [
    'input:not([type="hidden"]):not([disabled]):not([readonly])',
    'select:not([disabled]):not([readonly])',
    'textarea:not([disabled]):not([readonly])',
  ].join(',');

  wrapper.querySelector(fields).focus();
};

export const formatDate = (date) => dayjs(date).format(defaultDateMask());

export const getParam = (param) => new URLSearchParams(location.search).get(param) || '';

export const handleNotify = (json) => {
  const notifyAll = (items) => {
    for (const item of items) {
      if (typeof item === 'string') {
        notify({ title: item });
      } else if (item.body || item.title) {
        notify(item);
      } else if (item.id) {
        const options = item.id === 'global' ? { title: item.message } : { title: item.id, body: item.message };

        notify(options);
      } else if (item.message) {
        notify({ title: item.message });
      }
    }
  };

  if (json.title || json.body) {
    notifyAll([{ body: json.body, title: json.title }]);
  } else if (json.message) {
    notifyAll([json.message]);
  } else if (json.messages) {
    notifyAll(json.messages);
  } else if (json.error) {
    notifyAll([json.error]);
  } else if (json.errors) {
    notifyAll(json.errors);
  }
};

export const hide = (el) => {
  if (NodeList.prototype.isPrototypeOf(el)) {
    for (const item of el) {
      item.classList.add('hidden');
    }
  } else {
    el.classList.add('hidden');
  }
};

export const integer = (value) => parseInt(value, 10);

export const isEmpty = (value) => Object.keys(value).length === 0;

export const isIOS = () => document.querySelector('[data-param][name="ios"]').value === 'true';

export const isNotificationSupported = () => 'Notification' in window;

export const isPresent = (value) => value && value.trim() !== '';

export const isUserSignedIn = () => metaValue('user_signed_in') === 'true';

export const loading = (bool) => {
  const classList = document.querySelector('[data-global-loading]').classList;

  bool ? classList.remove('hidden') : classList.add('hidden');
};

export const metaValue = (key) => document.head.querySelector(`meta[name='${key}']`)?.content;

export const redirectTo = (url, query) => {
  window.location.href = query ? `${url}?${query}` : url;
};

export const reload = () => {
  setTimeout(() => location.reload(), 1000);
};

export const selectedLabel = (el) => {
  if (!el) return;
  if (el.selectedIndex === 0) return;

  return el.options[el.selectedIndex].text;
};

export const selectedValue = (el) => {
  if (!el) return;
  if (el.selectedIndex === 0) return;

  return el.value;
};

export const show = (el) => {
  if (NodeList.prototype.isPrototypeOf(el)) {
    for (const item of el) {
      item.classList.remove('hidden');
    }
  } else {
    el.classList.remove('hidden');
  }
};

export const throttle = (func, delay = 300) => {
  let timeout;

  const callback = (...args) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => func(args), delay);
  };

  return callback;
};

export const trigger = (element, eventName, json) => {
  element.dispatchEvent(new CustomEvent(eventName, { detail: json }));
};

export default class Helper {
  static closestData(el, selector) {
    while (el.parentNode) {
      el = el.parentNode;

      if (selector in el.dataset) {
        return el;
      }
    }

    return null;
  }

  static currencySymbol() {
    return 'R$';
  }

  static dateFormat() {
    return 'DD/MM/YY';
  }

  static goTo(url, query) {
    redirectTo(url, query);
  }

  static pushState(value) {
    const url = window.location.pathname + '?' + value;

    window.history.pushState(url, document.title, url);
  }

  static scrollTo(el) {
    const self = $(el);

    if (!self.length) return;

    $('html, body').animate({ scrollTop: self.offset().top - 100 }, 200);
  }
}
